export interface tokenDataState {
	accessToken?: string;
	expiresIn?: number;
	extendedExpiresIn?: number;
	refreshToken?: string;
	state?: string;
	ott?: string;
	contextId?: string;
	MSE_ott_ext_app?: string;
	returnUrl?: string;
}

export const tokenDataActions = {
	saveTokenData: '@tokenData/saveTokenData',
};
